///
/// EarthBrowser
///
/// Int16 quantization for computed pressure fields, shared by the synoptic
/// compute worker (encode) and the field texture frames (decode). Matches
/// the EBWX source precision of 0.1 hPa, so quantizing the blurred field
/// loses nothing. 0 marks invalid cells in both representations (real MSLP
/// is always far above 0.1 hPa x 32767 / 10).
///
/// Created by Matt Giger on 9/12/2026
/// Copyright (c) 2026 Geodata Labs
///

export const cFieldQuantScaleHpa = 0.1

export function quantizeField(src: Float32Array): Int16Array {
	const out = new Int16Array(src.length)
	for (let i = 0; i < src.length; i++) {
		const v = src[i]
		out[i] = v > 0 ? Math.min(32767, Math.round(v / cFieldQuantScaleHpa)) : 0
	}
	return out
}

export function dequantizeField(src: Int16Array): Float32Array {
	const out = new Float32Array(src.length)
	for (let i = 0; i < src.length; i++) {
		out[i] = src[i] * cFieldQuantScaleHpa
	}
	return out
}
